//
import { mapActions, mapState } from 'vuex'
import {
    ModelDataTable,
    VBtnAction,
} from '@/components/reusable_components/next'

//
import ProductModel from '@/models/Warehouse/WhProductToList'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'product-list',
    components: {
        ModelDataTable,
        VBtnAction,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                service: ProductModel,
                filters: filters({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                    triggerWarehouse: this.changeWarehouseFilter,
                }),
                headers,
                mapper: this.mapProduct,
                paramFilter: {
                    type: 'item',
                },
                rowsPerPage: 10,
            }
        },

        //
        ...mapState('AuthModule', ['user']),

        //
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    data() {
        return {
            branchOfficeId: 1,
            selected: null,
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
            setItemsTopBar: 'setItemsTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        changeWarehouseFilter(ctx) {
            //console.log(ctx.getInput( "of_warehouse" ).getSelected().g_branch_office_id )
            this.branchOfficeId =
                ctx.getInput('of_warehouse').getSelected().g_branch_office_id ||
                this.user.hr_employee.g_branch_office_id
        },

        /**
         *
         */
        refresh() {
            this.$refs.table.refresh()
        },

        /**
         *
         */
        deleteSelected() {
            this.selected
                .delete()
                .catch(this.showResponse)
                .then(this.resetSnackbar)
                .then(this.showResponse)
        },

        /**
         *
         */
        mapProduct(row) {
            //
            row.g_branch_office_id = this.branchOfficeId
            //
            return row
        },

        /**
         *
         */
        resetSnackbar(event) {
            this.resetSnackbarState()
            return event
        },

        /**
         *
         */
        showResponse(response) {
            switch (response.status) {
                case 200:
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Producto eliminado.',
                        this.refresh
                    )
                    break
                default:
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.message,
                        this.refresh
                    )
                    break
            }
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message))
            callback()
        },

        /**
         *
         */
        submitChildren(event) {
            this.$router.push({
                name: 'product-children',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        submitCreate() {
            this.$router.push({ name: 'product-create' })
        },

        /**
         *
         */
        submitDelete(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar item')
            this.showSnackbar(
                'warning',
                '¿Deseas eliminar el producto?',
                'Una vez eliminado no se puede recuperar.'
            )

            //
            this.selected = event.item
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'product-update',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Productos')
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: 'accent',
                icon: 'add_circle',
                text: 'crear producto',
                tip: 'Crear nuevo producto',
                can: 'CREATE_PRODUCT',
            },
        ])
    },
    mounted() {
        this.branchOfficeId = this.user.hr_employee.g_branch_office_id
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'eliminar item':
                    this.deleteSelected()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT')) ctx.$router.push('/')
        })
    },
}
